module.exports = __webpack_public_path__ + "img/IAR21.af0135ff.png";